// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__33hkq","buttons":"Footer_buttons__3X1ew"};